/* eslint-disable @nx/enforce-module-boundaries */
import { SamePathAppVersion } from './app.version.enum';

export function serveOxygenModuleLoader(app: string): Promise<any> {
    switch (window && (window as any)['clientConfig']?.['haApp']?.['samePathAppVersions']?.[app]) {
        case SamePathAppVersion.CORAL_MOBILE_APP:
            return import('@frontend/oxygen/cm-host-app').then((t) => t.CMHostAppModule);
        case SamePathAppVersion.CORAL_DESKTOP_APP:
            return import('@frontend/oxygen/cd-host-app').then((t) => t.CDHostAppModule);
        case SamePathAppVersion.LADBROKES_MOBILE_APP:
            return import('@frontend/oxygen/lm-host-app').then((t) => t.LMHostAppModule);
        case SamePathAppVersion.LADBROKES_DESKTOP_APP:
            return import('@frontend/oxygen/ld-host-app').then((t) => t.LDHostAppModule);
        default:
            return Promise.reject(new Error(`Unknown app version: ${app}`));
    }
}
